import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);
import auth from "./modules/auth";
import module from "./modules/module";
import cycle from "./modules/cycle";
import challenge from "./modules/challenge";
import {defaultModalSize, IS_ON_VACATION} from "@/constants/general";
import calendar from "./modules/calendar";
import metric from "./modules/metric"
import trail from "./modules/trail";
import week from "./modules/week";
import platform from "./modules/platform";
import subject from "./modules/subject";
import warnings from "./modules/warnings";
import {DEFAULT_MODAL_OPACITY, DEFAULT_MODAL_OVERLAY_COLOR} from "@/student/constants/general.js";
import { DEFAULT_LOADING_MESSAGE } from "../../constants/messages_info";


export default new Vuex.Store({
  state: {
    defaultModalSize,
    DEFAULT_MODAL_OPACITY,
    DEFAULT_MODAL_OVERLAY_COLOR,
    navbar_expanded: false,
    isLoading: false,
    showModalVideoLives: false,
    session_expired: false,
    user_desactivated: false,
    isLoadingMessage: 'Aguarde enquanto preparamos o ambiente pra você...',
    selectedYear: 2025,
    currentYear: (new Date()).getFullYear(),
  },
  mutations: {
    SET_IS_LOADING(state, {isLoading, message}) {
      state.isLoading = isLoading;
      state.isLoadingMessage = message;
    },
    SET_SESSION_EXPIRED(state, payload = true) {
      state.session_expired = payload;
    },
    SET_SHOW_MODAL_VIDEO_LIVES(state, payload) {
      state.showModalVideoLives = payload;
    },
    SET_USER_DESACTIVATED(state, payload = true) {
      state.user_desactivated = payload;
    },
    SET_YEAR(state, year){
      state.selectedYear = year
    }
  },
  actions: {
    isLoading({ commit }, params = {isLoading : true, message : DEFAULT_LOADING_MESSAGE}) {
      commit("SET_IS_LOADING", typeof( params) == 'object' ? params : {isLoading: params, message: DEFAULT_LOADING_MESSAGE})
    },
    load({ commit }, params = {isLoading : true, message : DEFAULT_LOADING_MESSAGE}) {
      commit("SET_IS_LOADING", typeof( params) == 'object' ? params : {isLoading: params, message: DEFAULT_LOADING_MESSAGE})
    }
  },
  getters:{
    isOnVacation(){
      return IS_ON_VACATION;
    },
    navbar_expanded : state => state.navbar_expanded,
    selectedYear: state => state.selectedYear,
    currentYear: state => state.currentYear,
  },
  modules: {
    auth,
    module,
    cycle,
    challenge,
    calendar,
    metric,
    trail,
    week,
    subject,
    warnings,
    platform,
  },

});
